
<div id="bulk-copy-dialog" class="ui modal">
  <i class="close icon"></i>
  <div class="header">対象店舗選択</div>
  <div class="scrolling content">
    <form class="ui form">
      <table class="ui selectable striped table">
        <thead>
          <tr>
            <th colspan="2">
              <input v-model="groupShopNameFilter" type="text" placeholder="店舗名で絞り込む">
            </th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="shop in filteredGroupShops" :key="shop.id" @click="toggle(shop)" class="clickable">
            <td><i v-if="isSelectedShop(shop)" class="green large check circle outline icon"></i></td>
            <td>{{ shop.name }}</td>
          </tr>
        </tbody>
      </table>
    </form>
  </div>
  <div class="actions">
    <div class="ui cancel button">閉じる</div>
    <div class="ui green button" :class="{loading: form.waiting, disabled: filteredSelectedGroupShops().length === 0}" @click="bulkCopy">{{ filteredSelectedGroupShops().length }}件に反映する</div>
  </div>
</div>
